module.exports = __webpack_public_path__ + "static/12-56e39d2a7cf2ebc5d44d73dc8fbc8c83.png";